// extracted by mini-css-extract-plugin
export default {"root":"IconPayPal_root__DCTR4"};